// extracted by mini-css-extract-plugin
module.exports = {"page":"SeoContent_page__98l8J","component":"SeoContent_component__Qj5Pb"};